import { Typography } from 'iglooform';
import { useIntl } from 'react-intl';
import { images } from '@/assets/images';

export const VerifyModal = ({ visible }: { visible: boolean }) => {
  const { formatMessage } = useIntl();

  return visible ? (
    <div className="verifySuccess">
      <img
        src={images.success_icon}
        style={{ width: '50px', height: '50px' }}
      />
      <div className="noteText">
        <Typography level="body1">
          {formatMessage({
            id: 'Email verified',
          })}
        </Typography>
        <Typography level="body1">
          {formatMessage({ id: 'Redirecting back to Ignite' })}
        </Typography>
      </div>
    </div>
  ) : (
    <></>
  );
};
